import { Card, CardContent, Link, Switch, Typography } from "@mui/material";
import {
  Automation,
  automationsService,
  AutomationStatus,
} from "services/admin/automationsService";
import { NavLink, Link as RouterLink } from "react-router-dom";
import { fromNow } from "helpers/dateHelper";
import { toast } from "react-toastify";

export const AutomationCard = ({ automation }: { automation: Automation }) => {
  if (!automation) {
    return null;
  }

  const handleChangeStatus = async () => {
    console.log("handleChangeStatus", automation);
    try {
      await automationsService.updateAutomation(automation.id, {
        status:
          automation.status === AutomationStatus.ACTIVE
            ? AutomationStatus.INACTIVE
            : AutomationStatus.ACTIVE,
      });
      toast.success("Статус автоматизации успешно обновлен");
    } catch (error) {
      console.error("Error updating automation status", error);
    }
  };
  return (
    <div>
      <Card>
        <CardContent>
          <div className="flex">
            <div className="flex" style={{ flex: 0.4 }}>
              <Switch
                size="small"
                defaultChecked={automation.status === AutomationStatus.ACTIVE}
                onChange={handleChangeStatus}
              />
              <NavLink
                to={`/admin/ai-agents/${automation.agentID}/automations/flow/${automation.id}`}
              >
                <div className="text-lg font-bold ml-4 cursor-pointer">{automation.name}</div>
              </NavLink>
            </div>
            <div className="flex justify-end items-center text-sm gap-4" style={{ flex: 0.6 }}>
              <div>38 запусков</div>
              <div>20 CTR %</div>
              <div>{fromNow(automation.updatedAt)}</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
